/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    NoCancellationSelected: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.NoCancellationSelected',
        defaultMessage: 'You have selected no cancellation cover, this means you will not be covered for any claims regarding cancellation prior to travel.'
    },
    RequireMoreCoverAnswer: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.RequireMoreCoverAnswer',
        defaultMessage: 'No, I need more cover'
    },
    AnswerRequired: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.AnswerRequired',
        defaultMessage: 'Please answer the question'
    },
    HeaderTitle: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.HeaderTitle',
        defaultMessage: 'Please answer the following question'
    },
    CancellationPerPersonOver15000: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.CancellationPerPersonOver15000',
        defaultMessage: 'The maximum cancellation limit available online is £15,000 per person.'
    },
    CancellationPerPersonOver15000Question: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.CancellationPerPersonOver15000Question',
        defaultMessage: 'If a claim is submitted under cancellation it will be limited to £15,000 per person. Are you happy to proceed?'
    },
    CancellationPerPersonOver15000Blocked: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.CancellationPerPersonOver15000Blocked',
        defaultMessage: 'Please call us on 0800 015 8055 to complete your quote'
    },
    CancellationOver2500Essential: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.CancellationOver2500Essential',
        defaultMessage: 'The maximum cancellation limit available on our Essential cover level is £2,500 per trip.'
    },
    CancellationOver2500EssentialQuestion: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.CancellationOver2500EssentialQuestion',
        defaultMessage: 'If you submit a claim for cancellation it will be limited to £2,500 in total. Do you want to go ahead?'
    },
    CancellationOver5KStandard: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.CancellationOver5KStandard',
        defaultMessage: 'The maximum cancellation limit available on our Standard cover level is £5,000 per person.'
    },
    CancellationOver5KStandardQuestion: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.CancellationOver5KStandardQuestion',
        defaultMessage: 'If you submit a claim for cancellation it will be limited to £5,000 per person. Do you want to go ahead?'
    },
    ExcessNot150Essential: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.ExcessNot150Essential',
        defaultMessage: 'Our Essential cover level has a fixed excess of £150. Other excess options are available on Standard and Plus.'
    },
    CancellationOver2500AndExcessNot150Essential: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.CancellationOver2500AndExcessNot150Essential',
        defaultMessage: 'Our Essential cover level has a fixed excess of £150. If you would like to amend your excess, please select either Standard or Plus cover.'
    },
    CancellationOver2500AndExcessNot150EssentialQuestion: {
        id: 'qnb.spt.SgSptCancellationExcessConflictModal.CancellationOver2500AndExcessNot150EssentialQuestion',
        defaultMessage: 'If you submit a claim for cancellation it will be limited to £2,500 in total. Do you want to go ahead with £2,500 cancellation cover and £150 excess?'
    },
});
